export default __webpack_public_path__ + "static/media/logistic-intro-course.4908819c.svg";